import { Link, useLocation } from 'react-router-dom';
import SEOHead from '../components/feature/SEOHead';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="bg-[#111] min-h-screen flex flex-col">
      <SEOHead
        title="404 — Page Not Found | CallOfDutyNext.com"
        description="This page could not be found. Head back to CallOfDutyNext.com for the latest Call of Duty news, patch notes, and Warzone updates."
        canonical={location.pathname}
        noIndex
      />
      {/* Minimal top bar */}
      <header className="border-b border-[#1e1e1e] bg-[#0d0d0d] px-6 h-14 flex items-center">
        <Link to="/" className="font-['Barlow_Condensed'] font-black text-white text-xl tracking-tight leading-none cursor-pointer">
          CALL<span className="text-[#999]">OF</span>DUTY<span className="text-[#00ff41] ml-1">NEXT</span>
        </Link>
      </header>

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-20">
        {/* Big 404 */}
        <div className="font-['Barlow_Condensed'] font-black text-[#1a1a1a] select-none leading-none mb-8"
          style={{ fontSize: 'clamp(120px, 20vw, 260px)' }}>
          404
        </div>

        {/* Content card */}
        <div className="border border-[#1e1e1e] bg-[#0d0d0d] max-w-lg w-full text-center -mt-16 relative z-10">
          <div className="border-b border-[#1e1e1e] px-8 py-4">
            <span className="inline-block font-['Barlow_Condensed'] font-bold text-xs tracking-wider text-white bg-[#2a2a2a] border border-[#3a3a3a] px-2 py-0.5">
              ERROR
            </span>
          </div>
          <div className="px-8 py-8">
            <h1 className="font-['Barlow_Condensed'] font-black text-white text-3xl uppercase mb-2">
              Page Not Found
            </h1>
            <p className="text-[#555] text-sm mb-2">
              Looks like this page went dark.
            </p>
            <code className="text-[#444] text-xs font-mono block mb-8">
              {location.pathname}
            </code>
            <div className="flex items-center justify-center gap-3">
              <Link
                to="/"
                className="font-['Barlow_Condensed'] font-black text-sm tracking-widest bg-[#00ff41] text-black px-6 py-3 hover:bg-[#00e63a] transition-colors cursor-pointer whitespace-nowrap"
              >
                HOME
              </Link>
              <Link
                to="/news"
                className="font-['Barlow_Condensed'] font-black text-sm tracking-widest border border-[#333] text-[#888] px-6 py-3 hover:border-[#666] hover:text-white transition-colors cursor-pointer whitespace-nowrap"
              >
                NEWS
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
